import React from 'react';
import { ThemeProvider } from 'react-css-themr';
import DatePicker from 'react-toolbox/lib/date_picker';

import theme from './theme';

function DatePickerRoot(props) {
  return (
    <ThemeProvider {...{ theme }}>
      <DatePicker {...props} />
    </ThemeProvider>
  );
}

export default DatePickerRoot;



// WEBPACK FOOTER //
// ./src/components/common/DatePickerCustom/root.jsx